
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/news/press-releases/[[...pageNumber]]",
      function () {
        return require("private-next-pages/[locale]/news/press-releases/[[...pageNumber]]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/news/press-releases/[[...pageNumber]]"])
      });
    }
  